export const enum USER_GROUPS {
  MANAGER = 'manager'
}

export const enum RESULTS_COUNT {
  COUNT_10 = 10,
  COUNT_20 = 20,
  COUNT_50 = 50,
  COUNT_100 = 100,
  COUNT_200 = 200,
  COUNT_500 = 500
}

export const enum SORTING_OPTIONS {
  CODE_DESC = 'code',
  CODE_ASC = '-code',
  NAME_DESC = 'name',
  NAME_ASC = '-name',
}

export const enum ROLE_CHAT_MESSAGE {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export enum BROKER_ACTIONS {
  CERT_EXISTS = 'cert_exists',
  CERT_MANUAL = 'cert_manual',
  CERT_SKIP = 'cert_skip',
  CERT_FIND_COST = 'cert_find_cost',
  CERT_FIND_MISSING_PRODUCT = 'cert_find_missing_product',
  CERT_FIND_MISSING_REGULATION = 'cert_find_missing_regulation'
}
